import { render, staticRenderFns } from "./PodAccel.vue?vue&type=template&id=39603e42&"
import script from "./PodAccel.vue?vue&type=script&lang=js&"
export * from "./PodAccel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports